import axios from 'axios';
import { z } from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

import { MenuPlannerStateDtoSchema } from '../schemas/MenuPlannerStateDto';

export const RequestBodySchema = z.array(z.string());
export type RequestBody = z.infer<typeof RequestBodySchema>;

const ResponseDataSchema = z.array(z.lazy(() => MenuPlannerStateDtoSchema));
export type ResponseData = z.infer<typeof ResponseDataSchema>;

export async function callApi(input: {
	requestBody: RequestBody;
}): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.BACKEND + `/MenuPlanner/GetMenuPlannerStatuses/statuses`;

	return await axios.post(url, input.requestBody).toOptionalMapped((x) => x.data);
}
